export const globalStylesDataKey = Symbol( 'globalStylesDataKey' );
export const globalStylesLinksDataKey = Symbol( 'globalStylesLinks' );
export const selectBlockPatternsKey = Symbol( 'selectBlockPatternsKey' );
export const reusableBlocksSelectKey = Symbol( 'reusableBlocksSelect' );
export const currentUserIdSelectKey = Symbol( 'currentUserIdSelect' );
export const userPatternCategoriesSelectKey = Symbol(
	'userPatternCategoriesSelect'
);
export const sectionRootClientIdKey = Symbol( 'sectionRootClientIdKey' );
export const mediaEditKey = Symbol( 'mediaEditKey' );
export const getMediaSelectKey = Symbol( 'getMediaSelect' );
export const isIsolatedEditorKey = Symbol( 'isIsolatedEditor' );
export const deviceTypeKey = Symbol( 'deviceTypeKey' );
export const isNavigationOverlayContextKey = Symbol(
	'isNavigationOverlayContext'
);
export const isNavigationPostEditorKey = Symbol( 'isNavigationPostEditor' );
export const mediaUploadOnSuccessKey = Symbol( 'mediaUploadOnSuccess' );
export const mediaSideloadFromUrlKey = Symbol( 'mediaSideloadFromUrl' );
export const openMediaEditorModalKey = Symbol( 'openMediaEditorModal' );
